import(/* webpackMode: "eager" */ "/usr/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/app/src/app/services/[slug]/components/ServiceClient.tsx");
;
import(/* webpackMode: "eager" */ "/usr/app/src/components/features/guide/guide-read-next.css");
